export default {"src":"/kaimono/_next/static/media/check.46fbf898.svg","height":36,"width":36};